'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPotentialResponders = undefined;

var _reselect = require('reselect');

var _buildPotentialResponders = require('conversations-schema/operators/widget-data/buildPotentialResponders');

var _getSendFromResponders = require('../../responders/selectors/getSendFromResponders');

var _getAgentRespondersList = require('./getAgentRespondersList');

var getPotentialResponders = exports.getPotentialResponders = (0, _reselect.createSelector)([_getSendFromResponders.getSendFromResponders, _getAgentRespondersList.getAgentRespondersList], _buildPotentialResponders.buildPotentialResponders);